import useBrandName from 'utility/hooks/useBrandName';

const statusUrlMap: Record<string, string> = {
	'Liquid Web': 'https://status.liquidweb.com',
	Nexcess: 'https://status.nexcess.com',
};

const defaultStatusUrl = statusUrlMap['Liquid Web'];

const useBrandStatusUrl = (): string => {
	const brandName = useBrandName();
	return statusUrlMap[brandName] ?? defaultStatusUrl;
};

export default useBrandStatusUrl;
